import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { TextareaModule } from 'primeng/textarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressBarModule } from 'primeng/progressbar';
import { AccordionModule } from 'primeng/accordion';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChipModule } from 'primeng/chip';
import { TabsModule } from 'primeng/tabs';
import { StepperModule } from 'primeng/stepper';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ColorPickerModule } from 'primeng/colorpicker';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
@NgModule({
  declarations: [],
  imports: [
    FileUploadModule,
    IftaLabelModule,
    MessageModule,
    MultiSelectModule,
    CommonModule,
    DatePickerModule,
    ButtonModule,
    ButtonGroupModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    InputNumberModule,
    CardModule,
    AvatarModule,
    MenuModule,
    BadgeModule,
    OverlayBadgeModule,
    SelectModule,
    TextareaModule,
    AutoCompleteModule,
    SelectButtonModule,
    SplitButtonModule,
    CheckboxModule,
    RadioButtonModule,
    TooltipModule,
    PanelMenuModule,
    ProgressBarModule,
    AccordionModule,
    ProgressSpinnerModule,
    ChipModule,
    TabsModule,
    StepperModule,
    ToastModule,
    ColorPickerModule,
    TableModule,
    TagModule,
  ],
  exports: [
    FileUploadModule,
    IftaLabelModule,
    MessageModule,
    MultiSelectModule,
    CommonModule,
    DatePickerModule,
    ButtonModule,
    ButtonGroupModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    InputNumberModule,
    CardModule,
    AvatarModule,
    MenuModule,
    BadgeModule,
    OverlayBadgeModule,
    SelectModule,
    TextareaModule,
    AutoCompleteModule,
    SelectButtonModule,
    SplitButtonModule,
    CheckboxModule,
    RadioButtonModule,
    TooltipModule,
    PanelMenuModule,
    ProgressBarModule,
    AccordionModule,
    ProgressSpinnerModule,
    ChipModule,
    TabsModule,
    StepperModule,
    ToastModule,
    ColorPickerModule,
    TableModule,
    TagModule,
  ],
})
export class PrimengModule {}
